import React from 'react';
import { DialogContentText } from '@mui/material';


export const HDialogContentText = ({ children, ...restProps }) => (
  <DialogContentText dividers {...restProps}>
    {children}
  </DialogContentText>
);
